import {add} from 'date-fns';

export default function getStampOfFutureDay(days: number, currentDate = new Date()): number {
  return add(currentDate, {days}).getTime();
}